import { hexToRGBA, theme } from 'theme';

import { Typography } from 'ui-widgets';

type FeaturesProps = {
  features: string[];
};

export function Features({ features }: FeaturesProps) {
  return (
    <div className="flex flex-col gap-1 absolute" style={containerStyle}>
      {features.map((feature) => {
        // copied from BottomProductInfo.tsx
        if (!shouldDisplayFeature(feature, features)) {
          return null;
        }

        return (
          <Typography
            key={String(feature)}
            variant="small"
            component="span"
            className="inline-block truncate"
            padding="2px 6px"
            fontSize="10px"
            color="white"
            borderRadius="12px"
            maxWidth="80px"
            sx={typographySx}
          >
            {feature}
          </Typography>
        );
      })}
    </div>
  );
}

////
// copied from BottomProductInfo.tsx
const shouldDisplayFeature = (feature: string, features: string[]) => {
  const isSpecialFeature = /^[$]+|Residential|Commercial$/i.test(feature);
  const hasManyFeatures = features.length > 3;
  return !hasManyFeatures || isSpecialFeature;
};

///
const containerStyle = {
  top: '8px',
  left: '8px',
};

const typographySx = {
  background: `${hexToRGBA(theme.palette.grey[600], 0.6)}`,
};
